<script setup>
import { usePlaylistStore } from "@/stores/playlist.js";
const plStore = usePlaylistStore();
import { ref, onMounted, watch } from 'vue';
import { enableScroll, scrollToSlide } from '@/Helpers/scroll.js'

const props = defineProps({
    brand: {
        type: Object,
        default: undefined,
    }
});

watch(
    () => plStore.currentSlideIndex,
    (newVal, prevVal) => {

        const timeline = document.querySelector('.timelineContainer')
        const timelineElem = document.querySelector('#playlistTimeline li:nth-child(' + (newVal + 1) + ')')
        const containerHeight = timeline.clientHeight
        const newOffset = (timelineElem.offsetTop - timeline.offsetTop) - (containerHeight / 2)

        timeline.scrollTo({
            behavior: "smooth",
            top: newOffset,
            left: 0
        })
    }
)

function scrollPlaylist(idx) {
    enableScroll()
    scrollToSlide(idx)
}
</script>

<template>
    <div class="flow-root">
        <ul id="playlistTimeline" role="list" class="-mb-8 overflow-scroll">
            <li v-for="(card, cardIdx) in plStore.cards" :key="card.id">
                <div class="relative pb-8">
                    <span
                        v-if="cardIdx < plStore.cards.length - 1"
                        class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                        aria-hidden="true"
                    />
                    <div class="relative flex space-x-3 items-center">
                        <div>
                            <span
                                class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                                :class="[
                                    { 'bg-(--brand-colour) text-white': plStore.currentSlideIndex < cardIdx },
                                    { 'bg-platform-orange-light text-(--brand-colour) border-2 border-(--brand-colour)': plStore.currentSlideIndex == cardIdx },
                                    { 'bg-green-600 text-white': plStore.currentSlideIndex > cardIdx }
                                ]"
                            >
                                <font-awesome-icon
                                    v-if="plStore.currentSlideIndex > cardIdx"
                                    icon="fa-light fa-circle-check"
                                    class="h-5 w-5"
                                    size="xl"
                                />
                                <font-awesome-icon
                                    v-if="plStore.currentSlideIndex < cardIdx"
                                    icon="fa-light fa-circle-stop"
                                    class="h-5 w-5"
                                    size="xl"
                                />
                                <font-awesome-icon
                                    v-if="plStore.currentSlideIndex == cardIdx"
                                    icon="fa-light fa-eye"
                                    class="h-5 w-5"
                                    size="xl"
                                />
                            </span>
                        </div>
                        <div class="flex min-w-0 flex-1 justify-between space-x-4">
                            <p class="text-md text-gray-500">
                                <a
                                    v-if="plStore.isGuest || plStore.isPlaylistComplete"
                                    role="link"
                                    :tabindex="cardIdx + 100"
                                    class="cursor-pointer"
                                    @click="scrollPlaylist(cardIdx)"
                                >
                                    {{ card.title }}
                                </a>
                                <span v-else>
                                    {{ card.title }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>